export function apiUrl(url) {
  return process.env.VUE_APP_API_URL + 'api/' + url;
};

export function baseUrl(url) {
  return process.env.VUE_APP_API_URL + url;
};
